module.exports = __webpack_public_path__ + "img/katarina_events_12.187c4f36.jpg";